import { Button, Modal } from "antd";
import { svg } from "../../../../Assets/svg";

interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess: any;
  quoteDisplayId: string;
  submitting: boolean;
}

const CreateOrderConfirmationModal: React.FC<Props> = ({
  open,
  onClose,
  onSuccess,
  quoteDisplayId,
  submitting,
}) => {
  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={svg?.closeIcon}
      width="33.75rem"
      className="commonModalClass"
      destroyOnClose={true}
      title={
        <div className="text-center fs-4 fw-bolder lh-m">Create Order</div>
      }
    >
      <div className="d-flex flex-column justify-content-center gap-4 py-3">
        <p className="text-center text-4a4a4a mb-0 fs-6">
          This action will create a new order based on{" "}
          <strong>#{quoteDisplayId}</strong> Quotation details. Please review
          all information before proceeding.
        </p>
        <div className="d-flex justify-content-center gap-3 mt-2">
          <Button
            onClick={onClose}
            className="btn btn-lg btn-outline-secondary h-auto px-5"
            disabled={submitting}
          >
            CLOSE
          </Button>

          <Button
            onClick={onSuccess}
            className={`btn btn-lg btn-primary h-auto px-5`}
            loading={submitting}
            disabled={submitting}
          >
            CREATE
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateOrderConfirmationModal;